const elFormOprosnik = document.querySelector('.form-oprosnik');

document.querySelector('.form-oprosnik__button-clear')?.addEventListener('click', () => {
    const elBtnSubmit = elFormOprosnik?.querySelector('.form-oprosnik__button-submit');

    elFormOprosnik?.reset();
    elBtnSubmit?.classList.add('btn_disabled');
    elBtnSubmit?.setAttribute('disabled', 'disabled');
});